export const formatToIso = (date) => {
  return new Date(date).toISOString();
};
